import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-body',
    templateUrl: './card-body.component.html',
    styleUrls: ['./card-body.component.scss'],
    standalone: false
})
export class CardBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
